import { render } from "./CustomerNotes.vue?vue&type=template&id=649bfcfe&ts=true"
import script from "./CustomerNotes.vue?vue&type=script&lang=ts"
export * from "./CustomerNotes.vue?vue&type=script&lang=ts"

import exportComponent from "/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__